// File: CarpenterAboutSection.jsx
// Pure CSS + dummy icons + one uploaded screenshot as reference

import { HandHeart, HeartPulse, Lightbulb, MapPinHouse, Mountain, MountainSnow, PersonStanding } from 'lucide-react';
import React from 'react';

export default function AboutUsCard3() {
  return (<>
    <section className="cp-wrap">
      <div className="cp-left">
        <div className="cp-icon"><HeartPulse size={50} color={`#222222`}/></div>
        <h2>ABOUT US</h2>
        <div className="cp-line"></div>

        <div className="cp-years">
          <div className="big-ac-3">100+</div>
          <div className="label-ac-3">Toppers In India Studied With Us</div>
        </div>

        <p className="cp-text">
          Te obtinuit ut adepto satis somno. Aliisque institutoribus iter deliciae vivet vita. Nam
          exempli gratia, quotiens ego vadam.
        </p>

        <div className="cp-feature-row">
          <div className="cp-feature">
            <div className="ficon-ac-3"><Mountain size={30} color={`#ffffff`}/></div>
            <div>
              <strong>FLAT RATE FEES</strong>
              <p>Te obtinuit ut adepto satis somno.</p>
            </div>
          </div>

          <div className="cp-feature">
            <div className="ficon-ac-3"><PersonStanding size={30} color={`#ffffff`}/></div>
            <div>
              <strong>24/7 CUSTOMER SUPPORT</strong>
              <p>Te obtinuit ut adepto satis somno.</p>
            </div>
          </div>
        </div>

        <button className="cp-btn">VIEW ALL ABOUT →</button>
      </div>

      <div className="cp-right">
        <form className="cp-form">
          <h3>GET A SYLLABUS</h3>

          <input type="text" placeholder="Your name" />
          <input type="email" placeholder="Your email" />
          <input type="number" placeholder="Your Mobile No" />
          <textarea placeholder="Your message (if any)"></textarea>

          <button className="submit-ac-3">SUBMIT</button>
        </form>
      </div><div className="cp-right-two">  <div className="feature-ac-3s">
         <div className="cp-years">
          <div className="big-ac-3">25</div>
          <div className="label-ac-3">Years Experience</div>
        </div>
            <div className="feature-ac-3">
              <div className="ficon-ac-3"><Lightbulb size={20} color={`#fff`} /></div>
              <div>
                <strong>Professional Service</strong>
                <p className="small-ac-3">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
              </div>
            </div>

            <div className="feature-ac-3">
              <div className="ficon-ac-3"><MapPinHouse size={20} color={`#fff`} /></div>
              <div>
                <strong>100% Service Guarantee</strong>
                <p className="small-ac-3">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
              </div>
            </div>
          </div></div>
    </section>
    <style>{`
/* File: CarpenterAboutSection.css */

.feature-ac-3s{ margin-top:18px}
.feature-ac-3{display:flex; gap:12px; align-items:flex-start; flex:1; margin-top:18px;
  background: rgba(144, 202, 249,0.51);padding:10px 15px;border-radius:10px;}
.ficon-ac-3{display:flex; align-items:center; justify-content:center; border-radius:10px; background:rgba(144, 202, 249,1);padding:8px 12px; }
.feature-ac-3 .small-ac-3{font-size:13px; margin:6px 0 0; opacity:0.9}

.cp-wrap {
  display: flex;margin-top:50px;
  padding:  60px 40px  0px ;padding-top:0px;
  background: #f6f6f6;
  gap: 40px;
}

.cp-left {
  flex: 1;padding-top:40px;padding-bottom:40px;
}

.cp-right {
  flex: 0.5;
  background: #ffffff;
  padding: 10px;
  border-left: 0px dashed rgba(144, 202, 249,1);
}
.cp-right-two {
  flex: 0.5;
  
}

.cp-icon {
  font-size: 42px;
  color: #c48a4a;
  margin-bottom: 10px;
}

.cp-left h2 {
  font-size: 34px;
  margin: 0;
  font-weight: 800;
  color: #333;
}

.cp-line {
  width: 60px;
  height: 4px;
  background: rgba(144, 202, 249,1);
  margin: 14px 0 26px;
}

.cp-years {
  display: flex;
  align-items: center;
  gap: 16px;
}

.big-ac-3 {
  font-size: 70px;
  font-weight: 800;
}

.label-ac-3 {
  font-size: 18px;
  font-weight: 600;
}

.cp-text {
  margin: 20px 0;
  max-width: 420px;
  color: #666;
}

.cp-feature-row {
  display: flex;
  gap: 30px;
  margin-top: 20px;
}

.cp-feature {
  display: flex;
  gap: 12px;
}

.ficon-ac-3 {
  font-size: 32px;
  color: rgba(144, 202, 249,1);;
}

.cp-btn {
  margin-top: 30px;
  padding: 12px 22px;
  background: #111;
  color: #fff;
  border-radius: 40px;
  border: none;
  cursor: pointer;
  font-weight: 600;
}

/* FORM */
.cp-form{}
.cp-form h3 {
  font-size: 26px;
  margin-bottom: 20px;
}

.cp-form input,
.cp-form textarea {
  width: 90%;
  padding: 14px;
  margin-bottom: 16px;
  border: none;
  border-bottom: 1px solid #bbb;
  background: transparent;
  outline: none;
}

textarea {
  height: 120px;
  resize: none;
}

.submit-ac-3 {
  background: rgba(144, 202, 249,1);;
  border: none;
  padding: 12px 24px;
  border-radius: 30px;
  color: #fff;
  cursor: pointer;
  font-weight: 600;
}

/* Responsive */
@media (max-width: 960px) {
  .cp-wrap {padding:  60px 10px  40px ;padding-top:40px;
    flex-direction: column;
  }
    .cp-feature-row { flex-direction: column;}
}`}</style>
    </>
  );
}
